function Feedback() {
  return (
    
    <div className="">
       <p>раздел в разработке</p>
    </div>
  );
}

export default Feedback;